<template>
  <div class="pricing-table-checkbox-container">
    <FriedCheckbox
      :id="inputId"
      :disabled="disabled"
      :aria-label="ariaLabel"
      :aria-labelledby="ariaLabel ? undefined : ariaLabelledBy"
      data-external="pricing-table-checkbox-input-edit"
      :model-value="inputValue === '1'"
      @update:model-value="handleUpdateChecked"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { Field } from '../../types';

const { disabled, input, ariaLabel, ariaLabelledBy } = defineProps<{
  disabled?: boolean;
  input?: Field;
  ariaLabel?: string;
  ariaLabelledBy?: string;
}>();

const emit = defineEmits<{
  'update-checked': [Partial<Field>, string];
}>();

const inputId = computed(() => input?.id);
const inputValue = computed(() => input?.value);

const handleUpdateChecked = (checked: boolean) => {
  if (!input) {
    return;
  }
  emit('update-checked', { ...input, value: checked ? '1' : '0' }, 'optionalProductFieldId');
};
</script>
<style lang="scss" scoped>
@import '../../scss/input-checkbox';

.pricing-table-checkbox-container {
  .checkbox-container {
    margin-top: 0;
    padding: 0;
  }
}
</style>
